<footer>

    <p>WebApp desarrollada para el <a href="https://www.rincondesoto.org">Ayuntamiento de Rincón de Soto</a></p>
    <p class="footer__author">por <a href="https://www.linkedin.com/in/santiago-garc%C3%ADa-llorente-a3b7b099/">Santiago García Llorente</a> en {{ angularVersion }}</p>
    <p>versión {{ appVersion }} | {{ releaseDate }} | <a [routerLink]="'/faq'">más info</a></p>
</footer>